var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const loadLottie = () => __awaiter(void 0, void 0, void 0, function* () { return yield import('lottie-web'); });
export const animationManifest = {
    helcimLogo: () => import('../lottie-animations/helcim-logo.json'),
    loader: () => import('../lottie-animations/loader.json'),
    loginAnimation9x16: () => import('../lottie-animations/login-animation-9x16.json'),
    purpleMan: () => import('../lottie-animations/purple-man.json'),
    loginAnimation16x9: () => import('../lottie-animations/login-animation-16x9.json'),
    signupBalloons: () => import('../lottie-animations/signup-balloons.json'),
    clouds: () => import('../lottie-animations/clouds-animation.json'),
    coinFeeSaver: () => import('../lottie-animations/coin-fee-saver-animation.json')
};
export function renderLottieAnimation(animationData) {
    return __awaiter(this, void 0, void 0, function* () {
        const container = document.getElementById(animationData.containerId);
        if (!container) {
            throw new Error('Container not found');
        }
        const data = yield animationManifest[animationData.name]();
        const { default: lottie } = yield loadLottie();
        const lottieInstance = lottie.loadAnimation({
            container,
            renderer: 'svg',
            loop: animationData.loop === false ? false : true,
            autoplay: true,
            animationData: data.default
        });
        return lottieInstance;
    });
}

//# sourceMappingURL=render-lottie-animation-utils.js.map
